// PaymentDetails.jsx

import Header from "../Components/Header";
import "./PaymentDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "../config";

const PaymentDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPaymentDetails();
  }, []);

  const fetchPaymentDetails = async () => {
    try {
      setLoading(true);

      const token = sessionStorage.getItem("token");

      const response = await axios.get(
        `${API_BASE}/payment/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPayment(response.data);
    } catch (error) {
      console.log("Error fetching payment details:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="payment-details-page">
        <Header />
        <h2 style={{ padding: "20px" }}>Loading payment details...</h2>
      </div>
    );
  }

  if (!payment) {
    return (
      <div className="payment-details-page">
        <Header />
        <h2 style={{ padding: "20px" }}>Payment not found</h2>
      </div>
    );
  }

  return (
    <div className="payment-details-page">
      <Header />

      {/* Title */}
      <div className="payment-details-title-row">
        <span
          className="payment-details-back-arrow"
          onClick={() => navigate("/payments")}
        >
          ←
        </span>

        <div>
          <h1>Payment Details</h1>
          <p>Transaction {payment.paymentNumber}</p>
        </div>
      </div>

      {/* Status Card */}
      <div className="payment-details-status-card">
        <div className="payment-details-success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="30px"
            viewBox="0 -960 960 960"
            width="30px"
            fill="#00a63e"
          >
            <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z" />
          </svg>
        </div>

        <h2>
          {payment.status === "Success"
            ? "Payment Completed"
            : payment.status}
        </h2>

        <h3>₹{payment.amount}</h3>
      </div>

      {/* Transaction Info */}
      <div className="payment-details-info-box">
        <h3>Transaction Information</h3>

        <div className="payment-details-info-grid">
          {/* Payment ID */}
          <div className="payment-details-info-card">
            <div className="payment-details-icon payment-details-red">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z"
                  stroke="#A21803"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 10H22"
                  stroke="#A21803"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <p>Payment ID</p>
              <h4>{payment.paymentNumber}</h4>
            </div>
          </div>

          {/* Order ID */}
          <div className="payment-details-info-card">
            <div className="payment-details-icon payment-details-pink">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#EECECD"
              >
                <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z" />
              </svg>
            </div>

            <div>
              <p>Order ID</p>
              <h4>{payment.orderNumber}</h4>
            </div>
          </div>

          {/* Date */}
          <div className="payment-details-info-card">
            <div className="payment-details-icon payment-details-yellow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M6.66675 1.6665V4.99984"
                  stroke="#D4AF37"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.3333 1.6665V4.99984"
                  stroke="#D4AF37"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335Z"
                  stroke="#D4AF37"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.5 8.3335H17.5"
                  stroke="#D4AF37"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <p>Transaction Date</p>

              <h4>
                {new Date(payment.createdAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </h4>
            </div>
          </div>

          {/* Customer */}
          <div className="payment-details-info-card payment-details-customer-card">
            <div className="payment-details-icon payment-details-purple">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M15.8334 17.5V15.8333C15.8334 14.9493 15.4822 14.1014 14.8571 13.4763C14.232 12.8512 13.3841 12.5 12.5001 12.5H7.50008C6.61603 12.5 5.76818 12.8512 5.14306 13.4763C4.51794 14.1014 4.16675 14.9493 4.16675 15.8333V17.5"
                  stroke="#9810FA"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.0001 9.16667C11.841 9.16667 13.3334 7.67428 13.3334 5.83333C13.3334 3.99238 11.841 2.5 10.0001 2.5C8.15913 2.5 6.66675 3.99238 6.66675 5.83333C6.66675 7.67428 8.15913 9.16667 10.0001 9.16667Z"
                  stroke="#9810FA"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <p>Customer</p>
              <h4>{payment.customerName}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Method */}
      <div className="payment-details-info-box">
        <h3>Payment Method</h3>

        <div className="payment-details-upi-box">
          <div className="payment-details-upi-left">
            <div className="payment-details-icon payment-details-red">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5Z"
                  stroke="#A21803"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 10H22"
                  stroke="#A21803"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <h4>{payment.paymentMethod}</h4>
              <p>{payment.customerEmail}</p>
            </div>
          </div>

          <span className="payment-details-verified">
            {payment.status}
          </span>

          <div className="payment-details-upi-bottom">
            <div>
              <p>Transaction ID</p>
              <h5>{payment.razorpayPaymentId || "N/A"}</h5>
            </div>

            <div>
              <p>Reference Number</p>
              <h5>{payment.razorpayOrderId || "N/A"}</h5>
            </div>
          </div>
        </div>
      </div>

      {/* Amount Breakdown */}
      <div className="payment-details-info-box">
        <h3>Amount Breakdown</h3>

        <div className="payment-details-amount-row">
          <span>Order Amount</span>
          <b>₹{payment.amount}</b>
        </div>

        <div className="payment-details-amount-row">
          <span>Payment Gateway Fee</span>
          <b>₹0</b>
        </div>

        <div className="payment-details-amount-row">
          <span>Discount Applied</span>
          <b className="payment-details-green-text">-₹0</b>
        </div>

        <div className="payment-details-amount-row payment-details-total-row">
          <span>Total Amount Paid</span>

          <b className="payment-details-red-text">
            ₹{payment.amount}
          </b>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;